import React from 'react';
import { Container, Row } from 'reactstrap';
import BasicAccordions from './Basic';
import AllClose from './AllClose';
import PrimaryColorAccordian from './PrimaryColorAccordian';
import SecondaryColorAccordian from './SecondaryColorAccordian';
import WithIcon from './WithIcon';
import WithOperand from './WithOperand';
import { Breadcrumbs } from '../../../AbstractElements';

const AccordionContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Accordion' parent='Ui Kits' title='Accordion' />
      <Row>
        <BasicAccordions />
        <AllClose />
        <PrimaryColorAccordian />
        <SecondaryColorAccordian />
        <WithIcon />
        <WithOperand />
      </Row>
    </Container>
  );
};
export default AccordionContainer;
